import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Leaf, Lock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import useSeo from "@/lib/useSeo";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  useSeo({ title: "Staff Login | Healthy Roots CMS", noindex: true });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) { toast.success("Welcome back"); nav("/admin"); }
    else toast.error(res.error || "Login failed");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-emerald-950 px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl p-8">
        <div className="flex flex-col items-center mb-7">
          <span className="w-14 h-14 rounded-full bg-emerald-800 text-amber-50 flex items-center justify-center mb-3"><Leaf size={26} /></span>
          <h1 className="font-serif text-2xl text-emerald-950">Healthy Roots CMS</h1>
          <p className="text-sm text-stone-500 mt-1">Staff sign in</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <label className="block"><span className="text-sm font-medium text-emerald-900">Email</span>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
              className="mt-1 w-full rounded-lg border border-stone-300 px-3 py-2.5 focus:ring-2 focus:ring-emerald-600 outline-none" /></label>
          <label className="block"><span className="text-sm font-medium text-emerald-900">Password</span>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password"
              className="mt-1 w-full rounded-lg border border-stone-300 px-3 py-2.5 focus:ring-2 focus:ring-emerald-600 outline-none" /></label>
          <button type="submit" disabled={busy} data-testid="login-submit"
            className="w-full rounded-full bg-emerald-800 text-amber-50 py-3 font-semibold hover:bg-emerald-900 transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
            <Lock size={16} /> {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
